<template>
  <div>
    <!-- 显示设置 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t('messageAdd.display.001') }}
        </span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.AutoBrightness") }}:</span>
        <el-select size="medium" v-model="d.a">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.BrightnessPercentage") }}:</span>
        <el-input-number v-model="d.b" :min="0" :max="100" style="width: 100%" size="medium"></el-input-number>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.SleepTime") }}:</span>
        <el-select size="medium" v-model="d.d">
          <el-option :label="$t('message.systemMsg.fifs')" :value="15"></el-option>
          <el-option :label="$t('message.systemMsg.thirtys')" :value="30"></el-option>
          <el-option :label="$t('message.systemMsg.onemin')" :value="60"></el-option>
          <el-option :label="$t('message.systemMsg.secmin')" :value="120"></el-option>
          <el-option :label="$t('message.systemMsg.fifmin')" :value="300"></el-option>
          <el-option :label="$t('message.systemMsg.tenmin')" :value="600"></el-option>
          <el-option :label="$t('message.systemMsg.thirtymin')" :value="1800"></el-option>
          <el-option :label="$t('message.systemMsg.NeverSleep')" :value="2147483647"></el-option>
        </el-select>
      </el-col>
      <!-- 搁置 -->
      <!-- <el-col :span="10" class="setting-box">
        <span class="setTitle">显示剩余电量:</span>
        <el-select size="medium"  v-model="d.sb">
          <el-option :label="$t('message.systemMsg.switchSelect.small')" :value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.default')" :value="2"></el-option>
        </el-select>
      </el-col> -->
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.fontSize") }}:</span>
        <el-select size="medium" v-model="d.fs">
          <el-option :label="$t('message.systemMsg.switchSelect.small')" value="0.85"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.default')" value="1.0"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.large')" value="1.15"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.maximum')" value="1.3"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.DisplaySize") }}:</span>
        <el-select size="medium" v-model="d.ds">
          <el-option :label="$t('message.systemMsg.switchSelect.small')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.default')" value="2"></el-option>
        </el-select>
      </el-col>
    </el-row>

    <!-- 壁纸设置 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t('messageAdd.display.002') }}
        </span>
      </el-col>
       <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("messageAdd.display.002") }}:</span>
        <el-button type="text" @click="manageWallpaper">{{ $t('messageAdd.display.003') }}</el-button>
      </el-col>
    </el-row>

    <!-- 壁纸设置弹框 -->
    <el-dialog :title="$t('messageAdd.display.002')" :visible.sync="wallpaperDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeWallpaperDialog">
      <el-form ref="WallpaperForm" label-width="160px" :model="wallpaperForm" :rules="wallpaperRules">
        <el-form-item :label="$t('messageAdd.display.004')" prop="t">
          <el-radio-group v-model="wallpaperForm.t"  @input="handleWallpaperRadioChange">
            <el-radio :label="0">{{$t('messageAdd.display.005')}}</el-radio>
            <el-radio :label="1">{{$t('messageAdd.display.007')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.display.008')" v-show="wallpaperForm.t===1">
          <el-upload
            class="upload-demo"
            ref="upload"
            action="#"
            :limit="1"
            accept=".png,.jpg,.jpeg"
            :on-change="handleWallpaperChange"
            :on-remove="handleWallpaperRemove"
            :on-exceed="handleWallpaperExceed"
            :file-list="fileList"
            list-type="picture"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">{{ $t('messageAdd.display.009') }}</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitWallpaperUpload">{{ $t('messageAdd.display.010') }}</el-button>
            <template slot="tip">
              <div class="el-upload__tip">
                <p>{{ $t("messageAdd.note.005") }}</p>
              </div>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.display.006')" v-show="wallpaperForm.t===0">
          <el-input v-model="wallpaperForm.url" :placeholder="$t('messageAdd.display.006')+'https:\/\/(http:\/\/)'" style="width: 350px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeWallpaperDialog">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="saveWallpaper">{{ $t("common.submit") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {uploadFile} from "@/api/stage";
export default {
  name: "DisplaySettings",
  props: {
    displaySet: {
      type: Object
    }
  },
  data() {
    return {
      wallpaperDialogVisible: false,
      wallpaperForm: {
        file: null,
        t: 0, // 0: URL, 1: File
        url: '',
        id: '',
        md5: '',
        name: '', // 文件名
        suffix: '', // 文件后缀
      },
      fileList: [],
      wallpaperRules: {},
    };
  },
  computed: {
    d() {
      return this.displaySet
    }
  },
  watch: {
    // 监听 d 的变化，并通知父组件
    d: {
      handler(newVal) {
        this.$emit('update:displaySet', newVal);
        this.$emit('update:config-displaySet', newVal);
      },
      deep: true // 深度监听对象的变化
    }
  },
  methods: {
    manageWallpaper() {
      this.wallpaperDialogVisible = true;
      this.$nextTick(() => {
        if (this.d.wp) {
          this.wallpaperForm.t = this.d.wp.t !== undefined ? this.d.wp.t : 0;
          if(this.wallpaperForm.t === 0) {
            this.wallpaperForm.url = this.d.wp.url || '';
          } else if(this.wallpaperForm.t === 1) {
            this.wallpaperForm.url = this.d.wp.url || '';
            this.wallpaperForm.id = this.d.wp.id || '';
            this.wallpaperForm.md5 = this.d.wp.md5 || '';
            this.wallpaperForm.name = this.d.wp.an || '';
            this.wallpaperForm.suffix = this.d.wp.bn || '';
            this.fileList = [{
              name: this.wallpaperForm.name+'.'+this.wallpaperForm.suffix,
              url: this.wallpaperForm.url,
            }];
            this.wallpaperForm.file = null;
          }
        } else {
          this.handleWallpaperRadioChange(0);
        }
      });
    },
    closeWallpaperDialog() {
      this.wallpaperDialogVisible = false;
    },
    handleWallpaperRadioChange(value) {
      // 切换上传方式时，清空之前的输入
      this.wallpaperForm.file = null;
      this.wallpaperForm.url = '';
      this.wallpaperForm.id = '';
      this.wallpaperForm.md5 = '';
      this.wallpaperForm.name = '';
      this.wallpaperForm.suffix = '';
      this.fileList = [];
      this.$refs.upload && this.$refs.upload.clearFiles();
    },
    handleWallpaperChange(file, fileList) {
      const isJPG = file.raw.type === 'image/jpeg';
      const isPNG = file.raw.type === 'image/png';
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isJPG && !isPNG) {
        this.$message.error(this.$t('messageAdd.display.011'));
        this.fileList = [];
        this.wallpaperForm.file = null;
        this.$refs.upload && this.$refs.upload.clearFiles();
        return;
      }
      if (!isLt10M) {
        this.$message.error(this.$t('messageAdd.display.012'));
        this.fileList = [];
        this.wallpaperForm.file = null;
        this.$refs.upload && this.$refs.upload.clearFiles();
        return;
      }

      this.wallpaperForm.file = file.raw;
      this.wallpaperForm.id = '';
      this.wallpaperForm.md5 = '';
      this.wallpaperForm.url = '';
      this.wallpaperForm.name = '';
      this.wallpaperForm.suffix = '';
      this.fileList = fileList;
    },
    handleWallpaperRemove(file, fileList) {
      this.wallpaperForm.file = null;
      this.wallpaperForm.id = '';
      this.wallpaperForm.md5 = '';
      this.wallpaperForm.url = '';
      this.wallpaperForm.name = '';
      this.wallpaperForm.suffix = '';
      this.fileList = fileList;
    },
    handleWallpaperExceed() {
      this.$message.warning(this.$t('messageAdd.display.015'));
    },
    submitWallpaperUpload() {
      if (!this.wallpaperForm.file) {
        this.$message.error(this.$t('messageAdd.display.013'));
        return;
      }
      let formData = new FormData();
      formData.append('fileList', this.wallpaperForm.file);
      formData.append('type', 4);
      const loading = this.$loading({
        lock: true,
        text: this.$t('messageAdd.manageCert.049'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      uploadFile(formData, 4).then(res => {
        if (res.success) {
          loading.close();
          this.wallpaperForm.id = res.data[0].id;
          this.wallpaperForm.md5 = res.data[0].md5;
          this.wallpaperForm.url = res.data[0].url;
          this.wallpaperForm.name = res.data[0].name;
          this.wallpaperForm.suffix = res.data[0].suffix;
          this.$message.closeAll();
          this.$message.success(this.$t('messageAdd.manageCert.050'));
        } else {
          loading.close();
          this.$message.closeAll();
          this.$message.error(this.$t(`code.${res.errorCode}`) + (res.errorInfo ? res.errorInfo : ''));
        }
      }).catch(() => {
        loading.close();
        this.$message.error(this.$t('common.operate_fail'));
      });
    },
    saveWallpaper() {
      if (this.wallpaperForm.t === 1) {
        if (!this.wallpaperForm.id) {
          this.$message.error(this.$t('messageAdd.display.014'));
          return;
        }
        if (!this.wallpaperForm.url) {
          this.$message.error(this.$t('messageAdd.display.013'));
          return;
        }
        this.$set(this.d, 'wp', {
          t: 1,
          id: this.wallpaperForm.id,
          url: this.wallpaperForm.url,
          md5: this.wallpaperForm.md5,
          an: this.wallpaperForm.name,
          bn: this.wallpaperForm.suffix
        });
      } else {
        if (!this.wallpaperForm.url) {
          this.$message.error(this.$t('messageAdd.display.016'));
          return;
        }
        this.$set(this.d, 'wp', {
          t: 0,
          url: this.wallpaperForm.url
        });
      }
      this.wallpaperDialogVisible = false;
      this.$message.success(this.$t('common.operate_success'));
    }
  },
}
</script>

<style lang="less" scoped>
.upload-demo {
  width: 350px;
}
.el-upload__tip {
  line-height: normal;
}
</style>